// Estilos usados exclusivamente pelos 3 Autocompletes de equipamento (Task 3 da
// decomposição de circuito/index.js) — os demais estilos do grupo "Equipamentos"
// (contentIdentation, gritItemTitle, linearProgress) são compartilhados com
// outras seções do formulário e continuam em circuito/styles.js
const styles = () => ({
	autoComplete: {
		"& .MuiInputBase-input": {
			padding: "4px 6px", // padding interno reduzido
			fontSize: "0.75rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.95rem", // fonte da label
		},
	},
	containerCheckOption: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
});

export default styles;
